module.exports = __webpack_public_path__ + "static/media/icon_4_Veranstaltungen_prev.a7a25311.png";